import React from 'react'
import './footer.css'
import {FaFacebook,FaGithub,FaLinkedin} from 'react-icons/fa'
// import {FiInstagram} from 'react-icons/fi'
// import {IoLogoTwitter} from 'react-icons/io'

export default function Footer() {
  return (
    <footer>
      <a href="#home" className="footer__logo">Trevor Moir</a>

      <ul className="permalinks">
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        {/* <li><a href="#testimonials">Testimonials</a></li> */}
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/trevor.moir.1" target="_blank" rel="noreferrer"><FaFacebook /></a>
        <a href="https://www.linkedin.com/in/trevor-moir-7690529a/" target="_blank" rel="noreferrer"><FaLinkedin /></a>
        <a href="https://github.com/trevormoir" target="_blank" rel="noreferrer"><FaGithub /></a>
        {/* <a href="https://instagram.com" target="_blank" rel="noreferrer"><FiInstagram /></a> */}
        {/* <a href="https://twitter.com" target="_blank" rel="noreferrer"><IoLogoTwitter /></a> */}
      </div>

      <div className="footer__copyright">
        <small>&copy;{new Date().getFullYear()} Trevor Moir. All rights reserved.</small>
      </div>
    </footer>
  )
}
